// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./app/components/calendar/calendar.main/calendar.schedule/calendar.schedule.item/calendar.schedule.item.scss
// module id = 4953
// module chunks = 50